<template>
  <div>
    <a-button
      type="primary"
      icon="plus"
      @click="showModal"
      style="margin-bottom: 20px"
    >
      {{ $t("action.ajouter") }}
    </a-button>
    <a-modal
      v-model="visibleModal"
      @cancel="handleCancel"
      :title="$t('all.enterInformationBelow')"
      :width="500"
      :height="1200"
      :footer="false"
    >
      <a-form :form="form" @submit="addService">
        <a-form-item :label="$t('etablissement.nom')">
          <a-input
            :placeholder="$t('etablissement.nom')"
            v-decorator="[
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: $t('requis.nom'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item :label="$t('etablissement.fournisseurNonRequis')">
          <a-select
            show-search
            option-filter-prop="children"
            :filter-option="filterOption"
            :placeholder="$t('etablissement.fournisseur')"
            v-decorator="[
              'provider',
              {
                rules: [
                  {
                    required: false,
                  },
                ],
              },
            ]"
          >
            <a-select-option v-for="provider in providers" :key="provider._id">
              {{ provider.fullName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('comptabilite.accountingClassReference')">
          <plan-comptable-select v-decorator="['accountingClass']" />
          <div class="text-muted small">
            {{ $t("comptabilite.accountingClassHint") }}
          </div>
        </a-form-item>
        <div class="form-actions mt-0">
          <a-button
            style="width: 150px"
            type="primary"
            htmlType="submit"
            :loading="loadingClasse"
            :disabled="loadingClasse"
            class="mr-3"
          >
            {{ $t("action.ajouter") }}
          </a-button>
          <a-button key="back" @click="handleCancel" :disabled="loadingClasse">
            {{ $t("action.annuler") }}
          </a-button>
        </div>
      </a-form>
    </a-modal>

    <a-modal
      :visible="assignVisible"
      :title="$t('comptabilite.accountingClassAssign')"
      :confirm-loading="assignSaving"
      :width="520"
      @ok="onAssignOk"
      @cancel="closeAssignModal"
      destroy-on-close
    >
      <a-form layout="vertical">
        <a-form-item :label="$t('comptabilite.accountingClassReference')">
          <plan-comptable-select v-model="assignClass" />
          <div class="text-muted small">
            {{ $t("comptabilite.accountingClassHint") }}
          </div>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-table
      :loading="tableLeading"
      :rowKey="'_id'"
      :columns="columns"
      :data-source="data"
      :pagination="true"
      :scroll="{ x: 'max-content' }"
    >
      <template slot="name" slot-scope="text, record">
        <a-input
          v-if="record.editable"
          type="text"
          :disabled="false"
          style="margin: -5px 0"
          :default-value="text"
          @change="(e) => handleChange(e.target.value, record._id, 'name')"
        />
        <div v-else>
          <template>
            {{ text }}
          </template>
        </div>
      </template>
      <a-select
        slot="provider"
        slot-scope="text, record"
        show-search
        v-if="record.editable"
        :autoFocus="true"
        style="width: 100%"
        :placeholder="$t('recette.fournisseur')"
        option-filter-prop="children"
        :filter-option="filterOption"
        @change="(e) => handleChange(e, record._id, 'provider')"
        :default-value="record.provider ? record.provider : ''"
      >
        <a-select-option
          v-for="provider in providers"
          :value="provider._id"
          :key="provider._id"
        >
          {{ provider.fullName }}
        </a-select-option>
      </a-select>
      <template v-else> {{ getProvider(record) }} </template>
      <template slot="accountingClass" slot-scope="text, record">
        <a-tag v-if="record.accountingClass" color="geekblue">
          {{ record.accountingClass }}
        </a-tag>
        <a-button
          v-else
          size="small"
          type="link"
          @click="openAssignModal(record)"
        >
          {{ $t("comptabilite.accountingClassAssign") }}
        </a-button>
      </template>
      <span slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a-button
              size="small"
              type="primary"
              @click="() => save(record._id)"
            >
              {{ $t("action.enregistrer") }}
            </a-button>
            <a-button size="small" type="danger">
              <a-popconfirm
                :title="$t('all.sureToCancelAlert')"
                @confirm="() => cancel(record._id)"
              >
                <a> {{ $t("action.annuler") }} </a>
              </a-popconfirm>
            </a-button>
          </span>
          <span v-else>
            <a-button
              type="primary"
              :disabled="editingKey !== ''"
              @click="() => edit(record._id)"
            >
              <a-icon type="edit" />{{ $t("action.modifier") }}
            </a-button>
          </span>
        </div>
      </span>
      <span slot="operationSupprimer" slot-scope="text, record">
        <div class="editable-row-operations">
          <span>
            <a-button :disabled="editingKey !== ''" type="danger">
              <a-popconfirm
                :title="$t('requis.supp')"
                @confirm="() => supp(record._id)"
              >
                <a>{{ $t("action.supprimer") }}</a>
              </a-popconfirm>
            </a-button>
          </span>
        </div>
      </span>
    </a-table>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import { showApiError } from "@/utilities/showApiError";
import PlanComptableSelect from "@/views/compV3/decaissement/components/PlanComptableSelect.vue";

var servicesData = [];
export default {
  name: "services",
  components: { PlanComptableSelect },
  computed: {
    columns() {
      return [
        {
          title: this.$t("etablissement.nom"),
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: this.$t("etablissement.fournisseurs"),
          dataIndex: "provider",
          key: "provider",
          scopedSlots: { customRender: "provider" },
        },
        {
          title: this.$t("comptabilite.accountingClass"),
          dataIndex: "accountingClass",
          key: "accountingClass",
          scopedSlots: { customRender: "accountingClass" },
        },
        {
          title: this.$t("action.modifier"),
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          fixed: "right",
        },
        {
          title: this.$t("action.supprimer"),
          dataIndex: "operationSupprimer",
          scopedSlots: { customRender: "operationSupprimer" },
          fixed: "right",
        },
      ];
    },
  },
  beforeMount() {
    this.form = this.$form.createForm(this, { name: "servicesForm" });
  },
  created() {
    this.$gtag.pageview({
      page_path: this.$route.path,
      page_location: window.location.href,
      page_title: document.title + " - Services",
    });
  },
  beforeCreate() {
    apiClient
      .post("/services/filter", {
        query: { status: "active" },
      })
      .then((res) => {
        servicesData = [...res.data];
        servicesData = servicesData.map((elem) => {
          return {
            ...elem,
            key: elem._id,
          };
        });
        this.data = servicesData;
        this.cacheData = servicesData.map((item) => ({ ...item }));
        this.tableLeading = false;
      })
      .catch((e) => this.$message.error(this.$t("error.aucService")));
    apiClient
      .post("/providers/filter", { query: {} })
      .then((res) => {
        this.providers = res.data;
      })
      .catch((e) => this.$message.error(this.$t("error.aucFournisseur")));
  },
  data() {
    return {
      tableLeading: true,
      visibleModal: false,
      form: this.$form.createForm(this),
      data: null,
      providers: [],
      cacheData: null,
      loadingClasse: false,
      activeService: "",
      editingKey: "",
      assignVisible: false,
      assignSaving: false,
      assignTarget: null,
      assignClass: "",
    };
  },
  methods: {
    handleChangeProvider(id) {
      this.activeService = id;
    },
    getProvider(record) {
      if (record.provider) {
        const provider = this.providers.filter(
          (el) => el._id == record.provider
        )[0];
        if (provider) return provider.fullName;
      }
      return "-";
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    addService(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.loadingClasse = true;

          apiClient
            .put("/services", { data: values })
            .then((res) => {
              this.$message.success(this.$t("success.serviceAjout"));
              this.data.push({
                ...res.data,
                key: res.data._id,
              });
              this.handleCancel();
            })
            .catch((e) => showApiError(this, e))
            .finally(() => (this.loadingClasse = false));
        }
      });
    },
    showModal() {
      this.visibleModal = true;
    },
    handleCancel() {
      this.form.resetFields();
      this.visibleModal = false;
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
      if (column === "provider") this.activeService = key;
    },
    edit(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    save(key) {
      let newData = [...this.data];
      let newCacheData = [...this.cacheData];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];
      const updates = { ...target };
      delete updates.editable;
      delete updates.key;
      delete updates.accountingClass;

      apiClient
        .patch("/services/" + key, { data: updates })
        .then(() => {
          if (target && targetCache) {
            delete target.editable;
            this.data = newData;
            Object.assign(targetCache, target);
            this.cacheData = newCacheData;
          }
          this.editingKey = "";
          this.$message.success(this.$t("success.serviceMSA"));
        })
        .catch(() => {
          this.$message.error(this.$t("error.serviceNonMSA"));
          this.cancel(key);
        });
      this.activeService = null;
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    },
    supp(key) {
      apiClient
        .patch("/services/" + key, { data: { status: "inactive" } })
        .then(() => {
          this.$message.success(this.$t("success.serviceSupp"));
          const dataSource = [...this.data];
          this.data = dataSource.filter((item) => item.key !== key);
        })
        .catch(() => this.$message.error(this.$t("error.serviceNonSupp")));
    },
    openAssignModal(record) {
      this.assignTarget = record;
      this.assignClass = "";
      this.assignVisible = true;
    },
    closeAssignModal() {
      this.assignVisible = false;
      this.assignTarget = null;
      this.assignClass = "";
    },
    onAssignOk() {
      if (!this.assignTarget || !this.assignClass) {
        this.$message.warning(
          this.$t("comptabilite.accountingClassParentMissingShort")
        );
        return;
      }
      this.assignSaving = true;
      apiClient
        .patch(`/services/${this.assignTarget._id}/assign-class`, {
          data: { accountingClass: this.assignClass },
        })
        .then((res) => {
          this.$message.success(this.$t("success.operationEffectue"));
          const idx = this.data.findIndex(
            (r) => r._id === this.assignTarget._id
          );
          if (idx !== -1) {
            this.$set(this.data, idx, {
              ...this.data[idx],
              accountingClass: res.data.accountingClass,
            });
          }
          this.closeAssignModal();
        })
        .catch((e) => showApiError(this, e))
        .finally(() => {
          this.assignSaving = false;
        });
    },
  },
};
</script>
<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
